/* Custom Colour Suite builder — paginated experience.
 *
 * COLOUR CODE (line-item property "Colour Code") is SUPPLIER-CRITICAL & locked:
 *   single side: <formula> | N" Root   (drop the pipe part if no root)
 *   Dimension Weft (dual): "Side 1: <s1> // Side 2: <s2>"
 * FORMULA CODE is internal only (attached as a property, never shown to the buyer).
 */
(function () {
  'use strict';
  if (window.__ccsBuilderInit) return;
  window.__ccsBuilderInit = true;

  /* ===================== CONFIG (editable) ===================== */
  var CONFIG = {
    // Parent categories — experience-only grouping. Order shown to the buyer.
    families: [
      { name: 'Tips',  methods: ['Nano', 'Silicone Nano', 'ThreadFlex Nano', 'I-Tip', 'K Tip', 'Mini K Tip'] },
      { name: 'Tapes', methods: ['Tape', 'InvisiFit Tape', 'Tape Weft', 'InvisiFit Tape Weft'] },
      { name: 'Wefts', methods: ['Classic Weft', 'Skinny Weft', 'Double Skinny Weft', 'Dimension Weft', 'Butterfly Weft'] }
    ],
    methodCodes: {
      'Nano': 'NT', 'Silicone Nano': 'SN', 'ThreadFlex Nano': 'TN',
      'I-Tip': 'IT', 'K Tip': 'KT', 'Mini K Tip': 'MK',
      'Classic Weft': 'WF', 'Skinny Weft': 'SW', 'Double Skinny Weft': 'SV', 'Dimension Weft': 'DW', 'Butterfly Weft': 'BF',
      'Tape': 'TP', 'InvisiFit Tape': 'IF', 'Tape Weft': 'TW', 'InvisiFit Tape Weft': 'IW'
    },
    // Unambiguous names for the order/process sheet. Option values stay as-is
    // (the builder matches them exactly); only the recorded properties use these.
    methodLabels: { 'Nano': 'Metal Nano' },
    rootLengths: ['None', '2"', '3"'],
    // Lengths to hide for now (matched by number). Empty the array to show them again.
    hiddenLengths: ['26', '28'],
    // No "Rooted" — a root is implied by choosing a root length.
    // cc = Colour Code letter (SUPPLIER); single uses "/" and exactly one colour.
    blends: [
      { name: 'Single colour', cc: '', code: 'SC', single: true,  min: 1, max: 1 },
      { name: 'Piano',         cc: 'P', code: 'PN', single: false, min: 2, max: 3 },
      { name: 'Mixed',         cc: 'M', code: 'MX', single: false, min: 2, max: 3 }
    ],
    dualSideMethods: ['Dimension Weft']
  };

  /* ===================== helpers ===================== */
  function unique(a) { return a.filter(function (v, i) { return a.indexOf(v) === i; }); }
  function strip(s) { return (s || '').replace(/^#/, '').replace(/^0/, ''); }
  function rootNum(l) { return (l || '').replace(/"/g, ''); }
  function lengthNum(l) { var m = (l || '').match(/\d+/); return m ? m[0] : ''; }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function blendByName(n) { return CONFIG.blends.filter(function (b) { return b.name === n; })[0]; }
  function isDual(st) { return CONFIG.dualSideMethods.indexOf(st.method) !== -1; }
  function weightGrams(w) { var p = (w || '').match(/\(([^)]*)\)/); var s = p ? p[1] : (w || ''); var m = s.match(/(\d+(?:\.\d+)?)\s*g\b/i); return m ? m[1].replace(/\.0$/, '') : ''; }
  function familyOf(m) { for (var i = 0; i < CONFIG.families.length; i++) if (CONFIG.families[i].methods.indexOf(m) !== -1) return CONFIG.families[i].name; return null; }

  /* ===================== option access ===================== */
  function optionIndex(p) {
    var names = (p.optionNames || []).map(function (n) { return (n || '').toLowerCase(); });
    function f(k, d) { var i = names.findIndex(function (n) { return n.indexOf(k) !== -1; }); return i === -1 ? d : i; }
    return { method: f('method', 0), length: f('length', 1), weight: f('weight', 2) };
  }
  function methodsFor(p) { var oi = optionIndex(p); return unique(p.variants.map(function (v) { return v.options[oi.method]; })); }
  // Lengths sorted numerically (16 → 28), not by Shopify's option order.
  function lengthsFor(p, m) {
    var oi = optionIndex(p);
    return unique(p.variants.filter(function (v) { return v.options[oi.method] === m; }).map(function (v) { return v.options[oi.length]; }))
      .sort(function (a, b) { return (Number(lengthNum(a)) || 0) - (Number(lengthNum(b)) || 0); });
  }
  // Weights sorted ascending by pack/bundle grams; unparseable (e.g. 7-Piece Set) last.
  function weightsFor(p, m, l) {
    var oi = optionIndex(p);
    return unique(p.variants.filter(function (v) { return v.options[oi.method] === m && v.options[oi.length] === l; }).map(function (v) { return v.options[oi.weight]; }))
      .sort(function (a, b) { return (Number(weightGrams(a)) || Infinity) - (Number(weightGrams(b)) || Infinity); });
  }
  function resolveVariant(p, st) { var oi = optionIndex(p); return p.variants.filter(function (v) { return v.options[oi.method] === st.method && v.options[oi.length] === st.length && v.options[oi.weight] === st.weight; })[0] || null; }

  /* ===================== market pricing ===================== */
  // The builder's baked-in prices (ccs_data metafield) are GBP catalogue values,
  // so on any non-GBP market the button must show the session's own contextual
  // price — never a GBP number wearing the local currency symbol. Prices come
  // from the ccs-price-probe section rendered on the product's own URL, where
  // Liquid exposes every variant at the session market's price (the
  // /products/{handle}.js AJAX endpoint silently omits priced variants under
  // Markets, so it can't be used for this).
  var marketPriceMaps = {};
  function marketPricesFor(handle) {
    if (!marketPriceMaps[handle]) {
      marketPriceMaps[handle] = fetch('/products/' + handle + '?section_id=ccs-price-probe', { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          var m = html && html.match(/<script[^>]*data-ccs-market-prices[^>]*>([\s\S]*?)<\/script>/);
          return m ? (JSON.parse(m[1]) || null) : null;
        })
        .catch(function () { return null; });
    }
    return marketPriceMaps[handle];
  }
  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) { return null; }
  }

  /* ===================== codes ===================== */
  // Colour tokens, with optional per-colour ratio (custom mode, non-single blend):
  // "8W:20%" when a ratio is set, else "8W".
  function colourTokens(side, b) {
    var custom = b && !b.single && side.ratioMode === 'custom';
    return (side.colours || []).map(function (c) {
      var t = strip(c.label);
      if (custom && side.ratios && side.ratios[c.label] != null) t += ':' + side.ratios[c.label] + '%';
      return t;
    });
  }
  function buildSide(side) {
    var b = blendByName(side.blend);
    if (!b) return '';
    if ((side.colours || []).length < b.min) return '';
    var hasRoot = side.rootLength && side.rootLength !== 'None' && side.rootShade;
    var rootToken = hasRoot ? 'T' + strip(side.rootShade.label) : '';
    var ct = colourTokens(side, b).join('/');
    var formula = b.single ? '#' + rootToken + '/' + ct : '#' + rootToken + b.cc + ct;
    if (hasRoot) formula += ' | ' + rootNum(side.rootLength) + '″ Root';
    return formula;
  }
  function buildColourCode(st) {
    if (isDual(st)) { var s1 = buildSide(st.sides[0]), s2 = buildSide(st.sides[1]); return (s1 && s2) ? ('Side 1: ' + s1 + ' // Side 2: ' + s2) : ''; }
    return buildSide(st.sides[0]);
  }
  // Live/partial code for the preview — builds as soon as colour selections start
  // (root → blend → shades), without waiting for the minimum to be met.
  function buildSidePartial(side) {
    var b = blendByName(side.blend);
    var hasRoot = side.rootLength && side.rootLength !== 'None' && side.rootShade;
    var rootToken = hasRoot ? 'T' + strip(side.rootShade.label) : '';
    var ct = colourTokens(side, b).join('/');
    if (!rootToken && !b && !ct) return '';
    var mid = b ? (b.single ? '/' : b.cc) : '';
    var s = '#' + rootToken + mid + ct;
    if (hasRoot) s += ' | ' + rootNum(side.rootLength) + '″ Root';
    return s;
  }
  function buildColourCodeDisplay(st) {
    if (isDual(st)) { var s1 = buildSidePartial(st.sides[0]), s2 = buildSidePartial(st.sides[1]); if (!s1 && !s2) return ''; return 'Side 1: ' + (s1 || '…') + ' // Side 2: ' + (s2 || '…'); }
    return buildSidePartial(st.sides[0]);
  }
  function sideCodeSeg(side) {
    var seg = [];
    if (side.rootShade) seg.push(strip(side.rootShade.label) + (side.rootLength && side.rootLength !== 'None' ? 'R' + lengthNum(side.rootLength) : 'N'));
    if ((side.colours || []).length) seg.push(side.colours.map(function (c) { return strip(c.label); }).join('-'));
    var b = blendByName(side.blend); if (b) seg.push(b.code);
    return seg.join('-');
  }
  function buildFormulaCode(st) {
    var parts = ['BW'];
    if (st.method) parts.push(CONFIG.methodCodes[st.method] || st.method.replace(/[^A-Za-z]/g, '').slice(0, 2).toUpperCase());
    if (st.length) parts.push(lengthNum(st.length));
    var wg = weightGrams(st.weight); if (wg) parts.push(wg);
    if (isDual(st)) parts.push('S1', sideCodeSeg(st.sides[0]), 'S2', sideCodeSeg(st.sides[1]));
    else { var seg = sideCodeSeg(st.sides[0]); if (seg) parts.push(seg); }
    return parts.filter(Boolean).join('-');
  }
  function sideSummary(s) {
    if (!s.blend && !s.colours.length) return '';
    var bits = [];
    if (s.colours.length) bits.push(s.colours.map(function (c) { return c.label; }).join(', '));
    if (s.blend) bits.push(s.blend);
    if (s.rootShade && s.rootLength && s.rootLength !== 'None') bits.push(s.rootShade.label + ' ' + s.rootLength + ' root');
    return bits.join(' · ');
  }

  /* ===================== validation ===================== */
  function coloursValid(side) { var b = blendByName(side.blend); if (!b) return false; var n = side.colours.length; return n >= b.min && n <= b.max; }
  function ratioValid(side) {
    var b = blendByName(side.blend);
    if (!b || b.single) return true;            // single: no ratio
    if (side.ratioMode !== 'custom') return true; // even split
    var labels = (side.colours || []).map(function (c) { return c.label; });
    if (!labels.length) return false;
    var sum = 0;
    for (var i = 0; i < labels.length; i++) { var v = side.ratios ? side.ratios[labels[i]] : null; if (v == null || isNaN(v) || v <= 0) return false; sum += Number(v); }
    return sum === 100;
  }
  function sideComplete(side) {
    if (!side.rootLength) return false;
    if (side.rootLength !== 'None' && !side.rootShade) return false;
    return coloursValid(side) && ratioValid(side);
  }
  function isComplete(st) {
    if (!(st.family && st.method && st.length && st.weight)) return false;
    return isDual(st) ? (sideComplete(st.sides[0]) && sideComplete(st.sides[1])) : sideComplete(st.sides[0]);
  }

  /* ===================== saved blends: reader ===================== */
  // "My saved blends" reads the customer metafield custom.saved_colours, which
  // snippets/ccs-saved-blends.liquid renders into <script data-ccs-saved>. The
  // members backend writes it when the builder saves (on add to cart, or with
  // Save blend) or deletes through the app proxy, see "saved blends: save and
  // delete" below. It writes shape 2, with its own id / name / savedAt /
  // variantId alongside `properties`.
  // The reader stays tolerant and normalises each entry from either shape:
  //   1. Builder state (preferred for any new writer):
  //      { name, savedAt, quality, method, length, weight, variantId, colourCode,
  //        sides: [{ rootLength: '2"', rootShade: '#6', blend: 'Piano',
  //                  colours: ['#8W', '#10'], ratioMode: 'custom',
  //                  ratios: { '#8W': 60, '#10': 40 } }] }
  //      A single-side blend may put rootLength / rootShade / blend / colours /
  //      ratios at the top level instead of in `sides`; a colour may be a label
  //      or { label, ratio }.
  //   2. The order line-item properties written by Add to cart, under
  //      `properties` or at the top level: 'Colour Code', _Quality, _Method,
  //      _Length, _Weight, Root, Blend, Colours, 'Side 1', 'Side 2'.
  // The list may be an array, { blends: [...] }, or a JSON string of either.
  function txt(v) { return v == null ? '' : String(v).trim(); }
  function sameText(a, b) { return txt(a).toLowerCase() === txt(b).toLowerCase(); }
  function firstText() { for (var i = 0; i < arguments.length; i++) { var v = arguments[i]; if (v != null && typeof v !== 'object' && txt(v) !== '') return txt(v); } return ''; }
  function splitList(s) { return txt(s) ? txt(s).split(/\s*,\s*/).filter(Boolean) : []; }
  function savedList(raw) {
    if (typeof raw === 'string') { try { raw = JSON.parse(raw); } catch (e) { return []; } }
    if (Array.isArray(raw)) return raw;
    if (raw && typeof raw === 'object') {
      var keys = ['blends', 'saved', 'items', 'saved_colours'];
      for (var i = 0; i < keys.length; i++) if (Array.isArray(raw[keys[i]])) return raw[keys[i]];
      return [raw];
    }
    return [];
  }
  function shadeLabelOf(c) { if (c == null) return ''; if (typeof c === 'object') return firstText(c.label, c.name, c.shade, c.code); return txt(c); }
  function ratioOf(c) {
    if (!c || typeof c !== 'object') return null;
    var v = parseFloat(c.ratio != null ? c.ratio : c.percentage != null ? c.percentage : c.percent != null ? c.percent : c.pct);
    return isNaN(v) ? null : v;
  }
  function blendFrom(v) {
    var s = txt(v);
    if (!s) return null;
    var hit = CONFIG.blends.filter(function (b) { return sameText(b.name, s) || sameText(b.code, s) || (b.cc && sameText(b.cc, s)); })[0];
    if (hit || s.length < 3 || s.charAt(0) === '#') return hit || null;
    // "Mix" -> "Mixed", "Single" -> "Single colour"
    return CONFIG.blends.filter(function (b) { return b.name.toLowerCase().indexOf(s.toLowerCase()) === 0; })[0] || null;
  }
  function rootLengthFrom(v) {
    var s = txt(v);
    if (!s) return '';
    if (/^(none|no)$/i.test(s)) return 'None';
    var n = lengthNum(s);
    return CONFIG.rootLengths.filter(function (l) { return l !== 'None' && lengthNum(l) === n; })[0] || '';
  }
  // Custom ratios only reach the order inside the Colour Code ("#T6P8W:60%/10:40%
  // | 2″ Root"). Read them back by position, which is the colour order the code
  // was built from; anything that doesn't line up is ignored (even split).
  function ratiosFromCode(code, labels) {
    var toks = txt(code).split(' | ')[0].split('/');
    if (!labels.length || toks.length !== labels.length) return null;
    var out = {};
    for (var i = 0; i < toks.length; i++) { var m = toks[i].match(/:(\d+(?:\.\d+)?)%\s*$/); if (!m) return null; out[labels[i]] = Number(m[1]); }
    return out;
  }
  function savedSide(rootLength, rootShade, blend, colours, ratios, ratioMode) {
    var custom = ratioMode ? ratioMode === 'custom' : (colours.length > 1 && colours.every(function (l) { return ratios[l] != null; }));
    return { rootLength: rootLength || (rootShade ? '' : 'None'), rootShade: rootShade || '', blend: blend, colours: colours, ratios: ratios, ratioMode: custom ? 'custom' : 'even' };
  }
  function sideFromObject(o) {
    if (!o || typeof o !== 'object') return null;
    var cols = o.colours || o.colors || o.shades || [];
    if (typeof cols === 'string') cols = splitList(cols);
    if (!Array.isArray(cols)) cols = [];
    var list = Array.isArray(o.ratios) ? o.ratios : null;
    var ratios = {}, labels = [];
    cols.forEach(function (c, i) {
      var l = shadeLabelOf(c);
      if (!l) return;
      labels.push(l);
      var r = ratioOf(c);
      if (r == null && list) { r = parseFloat(list[i]); if (isNaN(r)) r = null; }
      if (r != null) ratios[l] = r;
    });
    if (o.ratios && !list && typeof o.ratios === 'object') Object.keys(o.ratios).forEach(function (k) { var r = parseFloat(o.ratios[k]); if (!isNaN(r)) ratios[k] = r; });
    var rootShade = shadeLabelOf(o.rootShade || o.root_shade || o.rootColour || o.root_colour);
    return savedSide(rootLengthFrom(o.rootLength != null ? o.rootLength : o.root_length), rootShade, blendFrom(o.blend || o.blendStyle || o.blend_style), labels, ratios, o.ratioMode || o.ratio_mode);
  }
  // Root property: "#6 (2")" or "None".
  function sideFromProps(p) {
    var root = txt(p.Root), rootShade = '', rootLength = root ? 'None' : '';
    var m = root.match(/^(.*\S)\s*\(([^)]*)\)$/);
    if (m) { rootShade = m[1]; rootLength = rootLengthFrom(m[2]); }
    return savedSide(rootLength, rootShade, blendFrom(p.Blend), splitList(p.Colours), {});
  }
  // Dimension Weft side summary: "#8W, #10 · Piano · #6 2" root".
  function sideFromSummary(s) {
    var rootShade = '', rootLength = 'None', blend = null, colours = [];
    txt(s).split(' · ').forEach(function (part) {
      var b = blendFrom(part);
      if (b) { blend = b; return; }
      var m = part.match(/^(.*\S)\s+(\S+)\s+root$/i);
      if (m) { rootShade = m[1]; rootLength = rootLengthFrom(m[2]); return; }
      colours = splitList(part);
    });
    return savedSide(rootLength, rootShade, blend, colours, {});
  }
  function normaliseSaved(e, idx) {
    if (typeof e === 'string') { try { e = JSON.parse(e); } catch (x) { return null; } }
    if (!e || typeof e !== 'object' || Array.isArray(e)) return null;
    var p = (e.properties && typeof e.properties === 'object') ? e.properties : e;
    var n = {
      key: idx,
      id: firstText(e.id),
      orderName: firstText(e.orderName, e.order_name),
      name: firstText(e.name, e.title, e.label),
      savedAt: firstText(e.savedAt, e.saved_at, e.date, e.createdAt, e.created_at, e.updatedAt, e.updated_at),
      quality: firstText(e.quality, e.finish, p._Quality, p.Quality),
      method: firstText(e.method, p._Method, p.Method),
      length: firstText(e.length, p._Length, p.Length),
      weight: firstText(e.weight, p._Weight, p.Weight),
      variantId: firstText(e.variantId, e.variant_id, (e.variant && typeof e.variant === 'object') ? e.variant.id : e.variant),
      colourCode: firstText(e.colourCode, e.colour_code, e.colorCode, e.code, p['Colour Code']),
      sides: []
    };
    if (Array.isArray(e.sides) && e.sides.length) n.sides = e.sides.map(sideFromObject).filter(Boolean);
    else if (p['Side 1'] || p['Side 2']) n.sides = [sideFromSummary(p['Side 1']), sideFromSummary(p['Side 2'])];
    else if (p.Colours || p.Blend || p.Root) n.sides = [sideFromProps(p)];
    else { var s0 = sideFromObject(e); if (s0 && (s0.colours.length || s0.blend || s0.rootShade)) n.sides = [s0]; }
    // Fill custom ratios from the Colour Code when the entry didn't carry them.
    var halves = n.colourCode.split(' // ').map(function (h) { return h.replace(/^Side \d+:\s*/, ''); });
    n.sides.forEach(function (s, i) {
      if (!s.blend || s.blend.single || s.ratioMode === 'custom' || !halves[i]) return;
      var r = ratiosFromCode(halves[i], s.colours);
      if (r) { s.ratios = r; s.ratioMode = 'custom'; }
    });
    var restorable = n.method || n.variantId || n.sides.some(function (s) { return s.colours.length; });
    return restorable ? n : null;
  }
  function savedTime(n) { var t = n.savedAt ? Date.parse(n.savedAt) : NaN; return isNaN(t) ? null : t; }
  function formatSavedDate(v) {
    var t = v ? Date.parse(v) : NaN;
    if (isNaN(t)) return txt(v);
    var lang = document.documentElement.lang || 'en-GB';
    if (/^en$/i.test(lang)) lang = 'en-GB'; // the storefront says lang="en"; show 1 Oct 2026, not Oct 1
    try { return new Date(t).toLocaleDateString(lang, { day: 'numeric', month: 'short', year: 'numeric' }); }
    catch (e) { return new Date(t).toDateString(); }
  }
  // Undo CONFIG.methodLabels ('Metal Nano' on the order -> 'Nano' option value).
  function methodOptionName(m) {
    var w = txt(m);
    Object.keys(CONFIG.methodLabels).forEach(function (k) { if (sameText(CONFIG.methodLabels[k], w)) w = k; });
    return w;
  }
  // Exact option value, then case-insensitive, then a unique match on keyFn
  // (e.g. 18 vs 18", or 25g vs "1g Strands (25g Pack)").
  function matchOption(list, want, keyFn) {
    var w = txt(want);
    if (!w) return '';
    var hit = list.filter(function (x) { return x === w; })[0] || list.filter(function (x) { return sameText(x, w); })[0];
    if (hit) return hit;
    if (keyFn) { var k = keyFn(w); if (k) { var m = list.filter(function (x) { return keyFn(x) === k; }); if (m.length === 1) return m[0]; } }
    return '';
  }
  function findShade(list, label) {
    if (!label || !list) return null;
    var exact = list.filter(function (s) { return s.label === label; })[0];
    if (exact) return exact;
    var k = strip(label).toLowerCase();
    return list.filter(function (s) { return strip(s.label).toLowerCase() === k; })[0] || null;
  }

  /* ===================== instance ===================== */
  function emptySide() { return { rootLength: '', rootShade: null, blend: '', colours: [], ratioMode: 'even', ratios: {} }; }

  function initBuilder(rootEl) {
    var dataEl = rootEl.querySelector('[data-ccs-data]');
    if (!dataEl) return;
    var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var products = (data.products || []).filter(Boolean);
    if (!products.length) return;
    var product = products[0];
    // Two products = two finishes (Full Volume / Natural Finish). They share Type +
    // Method and differ in Length, so a Finish step slots in after Method and filters
    // the lengths. `product` is reassigned on finish so every renderer follows it.
    var MULTI = products.length > 1;
    var familyIcons = data.familyIcons || {};

    var state = { quality: MULTI ? '' : (product.quality || ''), finishIndex: null, family: '', method: '', length: '', weight: '', sides: [emptySide(), emptySide()], stepId: 'category' };

    var dom = {
      stage: rootEl.querySelector('[data-ccs-stage]'),
      progress: rootEl.querySelector('[data-ccs-progress]'),
      back: rootEl.querySelector('[data-ccs-back]'),
      next: rootEl.querySelector('[data-ccs-next]'),
      summary: rootEl.querySelector('[data-ccs-summary]'),
      colourCode: rootEl.querySelector('[data-ccs-colourcode]'),
      add: rootEl.querySelector('[data-ccs-add]'),
      msg: rootEl.querySelector('[data-ccs-msg]'),
      preview: rootEl.querySelector('[data-ccs-preview]'),
      toggle: rootEl.querySelector('[data-ccs-toggle]')
    };
    // When off, single-select steps don't auto-advance — the buyer taps Continue.
    var AUTO_ADVANCE = rootEl.dataset.ccsAutoadvance !== 'false';
    // Price is final once weight is picked (colour choices don't change it), so we
    // can surface it inline on the Add-to-cart button from that point.
    var SHOW_PRICE = rootEl.dataset.ccsPrice !== 'false';
    var ADD_LABEL = (dom.add && dom.add.textContent.trim()) || 'Add to cart';
    var SHOP_CURRENCY = rootEl.dataset.ccsShopCurrency || 'GBP';
    var ACTIVE_CURRENCY = rootEl.dataset.ccsCurrency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || SHOP_CURRENCY;
    // GBP sessions can trust the baked-in prices; anything else needs market ones.
    var NATIVE_PRICING = ACTIVE_CURRENCY === SHOP_CURRENCY;
    // Which market this session belongs to — keys into variant.marketPrices.
    // (Currency alone can't be the key: UAE sells in GBP off its own price list.)
    var MARKET = rootEl.dataset.ccsMarket || '';
    // Trade-tier fraction (display only — checkout applies the real discount).
    // Mirrors add-to-cart-button.liquid: price minus round(price * fraction).
    var TRADE = parseFloat(rootEl.dataset.ccsTrade) || 0;
    function tradePrice(cents) {
      var d = product.tradeExcluded ? 0 : TRADE;
      return d > 0 ? cents - Math.round(cents * d) : cents;
    }

    /* ---- step list (dynamic) ---- */
    var LABELS = { category: 'Type', method: 'Method', finish: 'Finish', length: 'Length', weight: 'Weight', rootLength: 'Root', rootColour: 'Root shade', blend: 'Blend', colours: 'Colours', ratio: 'Ratio', sides: 'Colours' };
    function stepList() {
      var s = MULTI ? ['category', 'method', 'finish', 'length', 'weight'] : ['category', 'method', 'length', 'weight'];
      if (isDual(state)) { s.push('sides'); return s; }
      s.push('rootLength');
      if (state.sides[0].rootLength && state.sides[0].rootLength !== 'None') s.push('rootColour');
      s.push('blend', 'colours');
      var b0 = blendByName(state.sides[0].blend);
      if (b0 && !b0.single) s.push('ratio');
      return s;
    }
    function reachable(stepId) {
      // a step is reachable if every prior step is valid
      var list = stepList();
      for (var i = 0; i < list.length; i++) { if (list[i] === stepId) return true; if (!stepValid(list[i])) return false; }
      return false;
    }

    /* ---- ui atoms ---- */
    function tile(label, sel, onClick, sub) { var b = el('button', 'ccs__tile' + (sel ? ' is-selected' : ''), '<span class="ccs__tile-t">' + label + '</span>' + (sub ? '<span class="ccs__tile-s">' + sub + '</span>' : '')); b.type = 'button'; b.addEventListener('click', onClick); return b; }
    function swatch(sh, sel, onClick) { var b = el('button', 'ccs__swatch' + (sel ? ' is-selected' : '')); b.type = 'button'; b.title = sh.label; var d = el('span', 'ccs__swatch-dot'); if (sh.image) d.style.backgroundImage = 'url("' + sh.image + '")'; else if (sh.color) d.style.background = sh.color; b.appendChild(d); b.appendChild(el('span', 'ccs__swatch-cap', sh.label)); b.addEventListener('click', onClick); return b; }
    function grid(cls) { return el('div', 'ccs__grid' + (cls ? ' ' + cls : '')); }
    function head(t, hint) { return el('p', 'ccs__step-h', t + (hint ? ' <span class="ccs__hint">' + hint + '</span>' : '')); }

    /* ---- per-step renderers (into stage) ---- */
    function renderCategory(s) {
      s.appendChild(head('Choose a type'));
      var g = grid('ccs__grid--types');
      CONFIG.families.forEach(function (fam) {
        var has = fam.methods.some(function (m) { return methodsFor(product).indexOf(m) !== -1; });
        if (!has) return;
        var icon = familyIcons[fam.name]; // full icon HTML (SVG mask span or FA <i>), or empty
        var b = el('button', 'ccs__tile ccs__tile--type' + (state.family === fam.name ? ' is-selected' : ''), (icon || '') + '<span class="ccs__tile-t">' + fam.name + '</span>');
        b.type = 'button';
        b.addEventListener('click', function () { if (state.family !== fam.name) { state.family = fam.name; state.method = ''; state.length = ''; state.weight = ''; } advance(); });
        g.appendChild(b);
      });
      s.appendChild(g);
    }
    function renderMethod(s) {
      s.appendChild(head('Method'));
      var g = grid();
      var fam = CONFIG.families.filter(function (f) { return f.name === state.family; })[0];
      var methods = (fam ? fam.methods : methodsFor(product)).filter(function (m) { return methodsFor(product).indexOf(m) !== -1; });
      methods.forEach(function (m) { g.appendChild(tile(m, state.method === m, function () { if (state.method !== m) { state.method = m; state.length = ''; state.weight = ''; } advance(); })); });
      s.appendChild(g);
    }
    function renderFinish(s) {
      s.appendChild(head('Finish', 'changes available lengths'));
      var g = grid();
      products.forEach(function (pr, i) {
        g.appendChild(tile(pr.quality || ('Finish ' + (i + 1)), state.finishIndex === i, function () {
          if (state.finishIndex !== i) {
            state.finishIndex = i;
            product = products[i];
            state.quality = product.quality || '';
            state.length = '';
            state.weight = '';
          }
          advance();
        }));
      });
      s.appendChild(g);
    }
    function renderLength(s) {
      s.appendChild(head('Length'));
      var g = grid('ccs__grid--pills');
      lengthsFor(product, state.method).filter(function (l) { return CONFIG.hiddenLengths.indexOf(lengthNum(l)) === -1; }).forEach(function (l) { g.appendChild(tile(l, state.length === l, function () { if (state.length !== l) { state.length = l; state.weight = ''; } advance(); })); });
      s.appendChild(g);
    }
    function renderWeight(s) {
      s.appendChild(head('Weight'));
      var g = grid('ccs__grid--pills');
      weightsFor(product, state.method, state.length).forEach(function (w) { g.appendChild(tile(w, state.weight === w, function () { state.weight = w; advance(); })); });
      s.appendChild(g);
    }
    function renderRootLength(s) {
      var side = state.sides[0];
      s.appendChild(head('Root', 'optional'));
      s.appendChild(el('p', 'ccs__sub', 'Add a darker root, or choose None.'));
      var g = grid('ccs__grid--pills');
      CONFIG.rootLengths.forEach(function (l) { g.appendChild(tile(l, side.rootLength === l, function () { side.rootLength = l; if (l === 'None') side.rootShade = null; render(); })); });
      s.appendChild(g);
    }
    function renderRootColour(s) {
      var side = state.sides[0];
      s.appendChild(head('Root shade'));
      var shades = (product.rootShades && product.rootShades.length) ? product.rootShades : product.shades;
      renderSwatchPicker(s, shades, side, 'single-root');
    }
    function renderBlend(s) {
      var side = state.sides[0];
      s.appendChild(head('Blend style'));
      var g = grid();
      CONFIG.blends.forEach(function (b) { g.appendChild(tile(b.name, side.blend === b.name, function () { side.blend = b.name; if (b.single && side.colours.length > 1) side.colours = side.colours.slice(0, 1); render(); }, b.single ? 'one shade' : 'two or three')); });
      s.appendChild(g);
    }
    function renderColours(s) {
      var side = state.sides[0];
      var b = blendByName(side.blend);
      var max = b ? b.max : CONFIG.maxColours, min = b ? b.min : 1;
      s.appendChild(head('Choose colours', (min === max ? ('pick ' + max) : ('pick ' + min + '–' + max)) + ' · ' + side.colours.length + ' selected'));
      renderColourPicker(s, side, max);
    }
    function renderSides(s) {
      s.appendChild(head('Colours', state.method + ' — two sides'));
      [0, 1].forEach(function (i) {
        var side = state.sides[i];
        var panel = el('div', 'ccs__side');
        panel.appendChild(el('p', 'ccs__side-h', 'Side ' + (i + 1)));
        // root length
        panel.appendChild(el('p', 'ccs__sub', 'Root'));
        var rg = grid('ccs__grid--pills');
        CONFIG.rootLengths.forEach(function (l) { rg.appendChild(tile(l, side.rootLength === l, function () { side.rootLength = l; if (l === 'None') side.rootShade = null; render(); })); });
        panel.appendChild(rg);
        // root shade (only if length)
        if (side.rootLength && side.rootLength !== 'None') {
          panel.appendChild(el('p', 'ccs__sub', 'Root shade'));
          renderSwatchPicker(panel, (product.rootShades && product.rootShades.length) ? product.rootShades : product.shades, side, 'root');
        }
        // blend
        panel.appendChild(el('p', 'ccs__sub', 'Blend'));
        var bg = grid();
        CONFIG.blends.forEach(function (b) { bg.appendChild(tile(b.name, side.blend === b.name, function () { side.blend = b.name; if (b.single && side.colours.length > 1) side.colours = side.colours.slice(0, 1); render(); }, b.single ? 'one' : '2–3')); });
        panel.appendChild(bg);
        // colours
        var bb = blendByName(side.blend);
        panel.appendChild(el('p', 'ccs__sub', 'Colours' + (bb ? ' <span class="ccs__hint">' + (bb.min === bb.max ? 'pick ' + bb.max : 'pick ' + bb.min + '–' + bb.max) + '</span>' : '')));
        renderColourPicker(panel, side, bb ? bb.max : 3);
        if (bb && !bb.single) { panel.appendChild(el('p', 'ccs__sub', 'Ratio')); renderRatio(panel, side); }
        s.appendChild(panel);
      });
    }
    function renderSwatchPicker(container, shades, side, mode) {
      if (!shades || !shades.length) { container.appendChild(el('p', 'ccs__note', 'No shades found (custom.colour).')); return; }
      var g = grid('ccs__grid--swatches');
      shades.forEach(function (sh) { g.appendChild(swatch(sh, side.rootShade && side.rootShade.label === sh.label, function () { side.rootShade = (side.rootShade && side.rootShade.label === sh.label) ? null : sh; render(); })); });
      container.appendChild(g);
    }
    function renderColourPicker(container, side, max) {
      var shades = product.shades || [];
      if (!shades.length) { container.appendChild(el('p', 'ccs__note', 'No shades found (custom.colour).')); return; }
      var g = grid('ccs__grid--swatches');
      shades.forEach(function (sh) {
        var idx = side.colours.map(function (c) { return c.label; }).indexOf(sh.label);
        g.appendChild(swatch(sh, idx !== -1, function () { if (idx !== -1) side.colours.splice(idx, 1); else if (side.colours.length < max) side.colours.push(sh); render(); }));
      });
      container.appendChild(g);
    }
    function renderRatio(container, side) {
      var modes = grid('ccs__grid--pills');
      [['even', 'Even split'], ['custom', 'Custom ratio']].forEach(function (m) {
        modes.appendChild(tile(m[1], (side.ratioMode || 'even') === m[0], function () { side.ratioMode = m[0]; render(); }));
      });
      container.appendChild(modes);
      if ((side.ratioMode || 'even') !== 'custom') { container.appendChild(el('p', 'ccs__note', 'Colours are blended evenly.')); return; }
      var total = el('p', 'ccs__ratio-total');
      function refreshTotal() {
        var sum = side.colours.reduce(function (a, c) { return a + (Number(side.ratios[c.label]) || 0); }, 0);
        total.className = 'ccs__ratio-total' + (sum === 100 ? ' is-ok' : '');
        total.textContent = 'Total: ' + sum + '%' + (sum === 100 ? ' ✓' : ' — must total 100%');
      }
      var list = el('div', 'ccs__ratios');
      side.colours.forEach(function (c) {
        var r = el('div', 'ccs__ratio-row');
        var dot = el('span', 'ccs__swatch-dot ccs__ratio-dot');
        if (c.image) dot.style.backgroundImage = 'url("' + c.image + '")'; else if (c.color) dot.style.background = c.color;
        r.appendChild(dot);
        r.appendChild(el('span', 'ccs__ratio-label', c.label));
        var inp = document.createElement('input');
        inp.type = 'number'; inp.min = '0'; inp.max = '100'; inp.step = '5'; inp.inputMode = 'numeric'; inp.className = 'ccs__ratio-input';
        inp.value = (side.ratios[c.label] != null ? side.ratios[c.label] : '');
        inp.addEventListener('input', function () {
          var v = inp.value === '' ? null : Math.max(0, Math.min(100, parseInt(inp.value, 10) || 0));
          if (v != null) v = Math.round(v / 5) * 5; // snap to 5s — no fine tuning
          if (v == null) delete side.ratios[c.label]; else side.ratios[c.label] = v;
          refreshTotal(); refresh(); // refresh updates preview + nav without rebuilding the inputs
        });
        inp.addEventListener('change', function () {
          inp.value = (side.ratios[c.label] != null ? side.ratios[c.label] : ''); // reflect the snapped value on blur
        });
        r.appendChild(inp); r.appendChild(el('span', 'ccs__ratio-pct', '%'));
        list.appendChild(r);
      });
      container.appendChild(list);
      refreshTotal();
      container.appendChild(total);
    }
    function renderRatioStep(s) { s.appendChild(head('Ratio', 'even, or set percentages')); renderRatio(s, state.sides[0]); }

    var RENDERERS = { category: renderCategory, method: renderMethod, finish: renderFinish, length: renderLength, weight: renderWeight, rootLength: renderRootLength, rootColour: renderRootColour, blend: renderBlend, colours: renderColours, ratio: renderRatioStep, sides: renderSides };

    /* ---- validity per step (enables Continue) ---- */
    function stepValid(id) {
      var s0 = state.sides[0];
      switch (id) {
        case 'category': return !!state.family;
        case 'method': return !!state.method;
        case 'finish': return state.finishIndex != null;
        case 'length': return !!state.length;
        case 'weight': return !!state.weight;
        case 'rootLength': return !!s0.rootLength;
        case 'rootColour': return !!s0.rootShade;
        case 'blend': return !!s0.blend;
        case 'colours': return coloursValid(s0);
        case 'ratio': return ratioValid(s0);
        case 'sides': return sideComplete(state.sides[0]) && sideComplete(state.sides[1]);
      }
      return false;
    }

    /* ---- navigation ---- */
    function goNext() { var list = stepList(), i = list.indexOf(state.stepId); if (i > -1 && i < list.length - 1 && stepValid(state.stepId)) { state.stepId = list[i + 1]; } render(); }
    // Single-select tiles call this: auto-advance if enabled, else just show the pick.
    function advance() { if (AUTO_ADVANCE) goNext(); else render(); }
    function goBack() { var list = stepList(), i = list.indexOf(state.stepId); if (i > 0) state.stepId = list[i - 1]; render(); }
    function goTo(id) { if (reachable(id)) { state.stepId = id; render(); } }

    /* ---- render ---- */
    function renderProgress() {
      var list = stepList();
      var curIdx = list.indexOf(state.stepId);
      dom.progress.innerHTML = '';
      list.forEach(function (id, i) {
        var done = stepValid(id), cur = id === state.stepId;
        // Position-based fill for the mobile track: past + current = filled, future = hollow.
        var cls = 'ccs__crumb' + (cur ? ' is-current' : '') + (done ? ' is-done' : '');
        if (i < curIdx) cls += ' is-past'; else if (i > curIdx) cls += ' is-future';
        var b = el('button', cls, '<span class="ccs__crumb-n">' + (i + 1) + '</span><span class="ccs__crumb-l">' + LABELS[id] + '</span>');
        b.type = 'button';
        b.addEventListener('click', function () { goTo(id); });
        dom.progress.appendChild(b);
      });
      // Keep the active step centred in the mobile horizontal track. Adjust ONLY the
      // track's scrollLeft — never scrollIntoView, which also scrolls the page
      // vertically and would snap the view up on long steps (e.g. the dual sides).
      var curEl = dom.progress.querySelector('.is-current');
      if (curEl && dom.progress.scrollWidth > dom.progress.clientWidth + 1) {
        var tr = dom.progress.getBoundingClientRect(), er = curEl.getBoundingClientRect();
        dom.progress.scrollLeft += (er.left + er.width / 2) - (tr.left + tr.width / 2);
      }
    }
    function renderNav() {
      var list = stepList(), idx = list.indexOf(state.stepId);
      dom.back.disabled = idx <= 0;
      var isLast = idx >= list.length - 1;
      dom.next.style.display = isLast ? 'none' : '';
      dom.next.disabled = !stepValid(state.stepId);
    }
    function renderStage() {
      var list = stepList();
      if (list.indexOf(state.stepId) === -1) state.stepId = list[list.length - 1];
      dom.stage.innerHTML = '';
      (RENDERERS[state.stepId] || function () {})(dom.stage);
    }
    function render() { renderStage(); renderProgress(); renderNav(); updatePreview(); }
    // Lighter update for live inputs (ratios): refresh progress/nav/preview without
    // rebuilding the stage, so number inputs keep focus.
    function refresh() { renderProgress(); renderNav(); updatePreview(); }

    /* ---- preview ---- */
    function row(k, v) { var r = el('div', 'ccs__summary-row'); r.appendChild(el('dt', null, k)); r.appendChild(el('dd', null, v || '—')); return r; }
    function updatePreview() {
      dom.summary.innerHTML = '';
      if (state.quality) dom.summary.appendChild(row('Quality', state.quality));
      dom.summary.appendChild(row('Type', state.family));
      dom.summary.appendChild(row('Method', state.method));
      dom.summary.appendChild(row('Length', state.length));
      dom.summary.appendChild(row('Weight', state.weight));
      if (isDual(state)) { [0, 1].forEach(function (i) { dom.summary.appendChild(row('Side ' + (i + 1), sideSummary(state.sides[i]))); }); }
      else {
        var s0 = state.sides[0];
        dom.summary.appendChild(row('Root', (s0.rootLength && s0.rootLength !== 'None' && s0.rootShade) ? (strip(s0.rootShade.label) + ' · ' + s0.rootLength) : (s0.rootLength === 'None' ? 'None' : '—')));
        dom.summary.appendChild(row('Blend', s0.blend));
        dom.summary.appendChild(row('Colours', s0.colours.length ? s0.colours.map(function (c) { return c.label; }).join(', ') : ''));
      }
      var code = buildColourCode(state);
      dom.colourCode.textContent = buildColourCodeDisplay(state) || '—';

      var variant = (state.method && state.length && state.weight) ? resolveVariant(product, state) : null;
      var ready = isComplete(state) && !!variant && !!code;
      if (dom.add) {
        dom.add.disabled = !ready;
        dom.add.dataset.variantId = variant ? variant.id : '';
        var priceLabel = '';
        if (SHOW_PRICE && variant) {
          var baked = (variant.marketPrices && MARKET && variant.marketPrices[MARKET]) || null;
          if (baked && baked.a != null) {
            var f = formatMoney(tradePrice(baked.a), baked.c);
            if (f) priceLabel = ' · ' + f;
          } else if (NATIVE_PRICING && variant.price != null) {
            var fn = formatMoney(tradePrice(variant.price), SHOP_CURRENCY);
            if (fn) priceLabel = ' · ' + fn;
          }
        }
        dom.add.textContent = ADD_LABEL + priceLabel;
        if (SHOW_PRICE && variant && !priceLabel && !NATIVE_PRICING) {
          // No baked price for this market (stale metafield / new market): ask the
          // storefront probe, which at least covers the market-listed variants.
          var vid = String(variant.id);
          marketPricesFor(product.handle).then(function (data) {
            if (dom.add.dataset.variantId !== vid) return; // selection moved on while fetching
            var entry = data && data.prices ? data.prices[vid] : null;
            if (entry && entry.cents != null) {
              var pf = formatMoney(tradePrice(entry.cents), data.currency);
              if (pf) dom.add.textContent = ADD_LABEL + ' · ' + pf;
            }
          });
        }
      }
      // Save blend (only with the saved-blends panel) is enabled exactly like Add
      // to cart, and stays off while a save is in flight.
      if (saveUi) saveUi.btn.disabled = !ready || saveUi.busy;
      dom.msg.textContent = (isComplete(state) && !variant) ? 'That combination isn’t available — try a different length or weight.' : '';
    }

    /* ---- add to cart ---- */
    function cartProperties(code) {
      // Visible in cart: Colour Code + the colour-relevant rows. Hidden (_-prefixed,
      // still on the order for the supplier pipeline): formula + the values already
      // shown in the variant title (quality/method/length/weight).
      var props = { 'Colour Code': code, '_Formula': buildFormulaCode(state), '_Quality': state.quality, '_Method': CONFIG.methodLabels[state.method] || state.method, '_Length': state.length, '_Weight': state.weight };
      if (isDual(state)) { props['Side 1'] = sideSummary(state.sides[0]); props['Side 2'] = sideSummary(state.sides[1]); }
      else { var s0 = state.sides[0]; props['Root'] = (s0.rootShade && s0.rootLength !== 'None') ? (s0.rootShade.label + ' (' + s0.rootLength + ')') : 'None'; props['Blend'] = s0.blend; props['Colours'] = s0.colours.map(function (c) { return c.label; }).join(', '); }
      return props;
    }
    if (dom.add) dom.add.addEventListener('click', function () {
      var id = dom.add.dataset.variantId, code = buildColourCode(state);
      if (!id || !code) return;
      var props = cartProperties(code);
      dom.add.disabled = true; dom.msg.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1, properties: props }] }) })
        .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message || 'Could not add to cart'); }); return r.json(); })
        .then(function () { autoSaveBlend(id, code, props); document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); window.location.href = '/cart'; })
        .catch(function (err) { dom.msg.textContent = err.message || 'Something went wrong.'; dom.add.disabled = false; });
    });
    // nav buttons
    if (dom.back) dom.back.addEventListener('click', goBack);
    if (dom.next) dom.next.addEventListener('click', goNext);
    if (dom.toggle) dom.toggle.addEventListener('click', function () { dom.preview.classList.toggle('is-open'); });
    // Non-eligible visitors get a button that opens the trade pop-up (trade-gate.js).
    // If that modal isn't on the page (e.g. an editor preview), fall back to the login page.
    var loginBtn = rootEl.querySelector('.ccs__login[data-trade-gate-open]');
    if (loginBtn) loginBtn.addEventListener('click', function () {
      if (!document.querySelector('dialog[data-trade-modal]') && loginBtn.getAttribute('data-login-url')) window.location.href = loginBtn.getAttribute('data-login-url');
    });

    /* ---- saved blends: recall panel ---- */
    // Only rendered by Liquid for logged-in customers who pass ccs-eligible, so
    // no panel element = nothing to do. Load writes the entry into `state` the
    // same way the step tiles do, then lands on the first step still needing a
    // choice (or the last step when the blend is complete, ready for Add to cart).
    var saved = {
      panel: rootEl.querySelector('[data-ccs-saved-panel]'),
      list: rootEl.querySelector('[data-ccs-saved-list]'),
      empty: rootEl.querySelector('[data-ccs-saved-empty]'),
      count: rootEl.querySelector('[data-ccs-saved-count]'),
      msg: rootEl.querySelector('[data-ccs-saved-msg]'),
      data: rootEl.querySelector('[data-ccs-saved]')
    };
    function variantById(id) {
      for (var i = 0; i < products.length; i++) {
        var v = products[i].variants.filter(function (x) { return String(x.id) === String(id); })[0];
        if (v) return { index: i, variant: v };
      }
      return null;
    }
    function restoreSide(ns, roots, missing) {
      var side = emptySide();
      if (!ns) return side;
      var b = ns.blend;
      side.rootLength = ns.rootLength || '';
      if (side.rootLength && side.rootLength !== 'None' && ns.rootShade) {
        side.rootShade = findShade(roots, ns.rootShade);
        if (!side.rootShade) missing.push(ns.rootShade + ' root');
      }
      if (b) side.blend = b.name;
      ns.colours.forEach(function (l) {
        var sh = findShade(product.shades, l);
        if (!sh) { missing.push(l); return; }
        if ((b && side.colours.length >= b.max) || side.colours.some(function (c) { return c.label === sh.label; })) return;
        side.colours.push(sh);
        if (ns.ratios[l] != null) side.ratios[sh.label] = ns.ratios[l];
      });
      if (b && !b.single && ns.ratioMode === 'custom') side.ratioMode = 'custom';
      else side.ratios = {};
      return side;
    }
    function applySaved(n) {
      var missing = [], note = '';
      var byId = n.variantId ? variantById(n.variantId) : null;
      if (MULTI) {
        var fi = -1;
        if (n.quality) products.forEach(function (pr, i) { if (fi === -1 && sameText(pr.quality, n.quality)) fi = i; });
        if (fi === -1 && byId) fi = byId.index;
        if (fi > -1) { state.finishIndex = fi; product = products[fi]; state.quality = product.quality || ''; }
        else { state.finishIndex = null; state.quality = ''; if (n.quality) missing.push(n.quality); }
      } else if (n.quality && product.quality && !sameText(n.quality, product.quality)) {
        note = ' It was saved as ' + n.quality + ' and has been loaded as ' + product.quality + '.';
      }
      // Option text first; the variant id fills any gaps when it belongs to this finish.
      var want = { method: methodOptionName(n.method), length: n.length, weight: n.weight };
      if (byId && products[byId.index] === product) {
        var oi = optionIndex(product), o = byId.variant.options;
        if (!want.method) want.method = o[oi.method];
        if (!want.length) want.length = o[oi.length];
        if (!want.weight) want.weight = o[oi.weight];
      }
      var method = matchOption(methodsFor(product), want.method);
      if (want.method && !method) missing.push(want.method);
      state.method = method;
      state.family = method ? (familyOf(method) || '') : '';
      var lengths = method ? lengthsFor(product, method).filter(function (l) { return CONFIG.hiddenLengths.indexOf(lengthNum(l)) === -1; }) : [];
      state.length = matchOption(lengths, want.length, lengthNum);
      if (method && want.length && !state.length) missing.push(want.length);
      var weights = state.length ? weightsFor(product, method, state.length) : [];
      state.weight = matchOption(weights, want.weight, weightGrams);
      if (state.length && want.weight && !state.weight) missing.push(want.weight);
      var roots = (product.rootShades && product.rootShades.length) ? product.rootShades : product.shades;
      state.sides = [restoreSide(n.sides[0], roots, missing), restoreSide(n.sides[1], roots, missing)];

      var list = stepList(), target = list[list.length - 1];
      for (var i = 0; i < list.length; i++) { if (!stepValid(list[i])) { target = list[i]; break; } }
      state.stepId = target;
      render();

      var ready = isComplete(state) && !!resolveVariant(product, state) && !!buildColourCode(state);
      var m = ready ? 'Blend loaded. Check the details, then add to cart.' : 'Blend loaded. Please finish the highlighted step to continue.';
      if (missing.length) m = 'Blend loaded, but some of it is no longer available (' + missing.join(', ') + '). Please choose again to continue.';
      if (saved.msg) saved.msg.textContent = m + note;
      // Collapse the list so the restored step is in view; keep focus on the panel.
      saved.panel.open = false;
      var sum = saved.panel.querySelector('summary');
      if (sum) sum.focus();
    }
    function savedDot(label, pool) {
      var dot = el('span', 'ccs__swatch-dot ccs__saved-dot');
      var sh = findShade(pool, label);
      if (sh && sh.image) dot.style.backgroundImage = 'url("' + sh.image + '")';
      else if (sh && sh.color) dot.style.background = sh.color;
      dot.title = label;
      return dot;
    }
    function savedShadesText(n) {
      return n.sides.map(function (s, i) {
        var t = s.colours.map(function (l) { return l + (s.ratioMode === 'custom' && s.ratios[l] != null ? ' ' + s.ratios[l] + '%' : ''); }).join(', ');
        if (s.blend) t += (t ? ', ' : '') + s.blend.name.toLowerCase();
        if (s.rootShade && s.rootLength && s.rootLength !== 'None') t += (t ? ', ' : '') + s.rootShade + ' ' + s.rootLength + ' root';
        return (n.sides.length > 1 ? 'Side ' + (i + 1) + ': ' : '') + t;
      }).join('; ');
    }
    function renderSaved(entries) {
      var pool = [];
      products.forEach(function (pr) { pool = pool.concat(pr.shades || [], pr.rootShades || []); });
      saved.list.innerHTML = '';
      entries.forEach(function (n) {
        var title = n.name || formatSavedDate(n.savedAt) || ('Saved blend ' + (n.key + 1));
        var li = el('li', 'ccs__saved-item');
        var info = el('div', 'ccs__saved-info');
        var h = el('p', 'ccs__saved-name'); h.textContent = title; info.appendChild(h);
        var meta = [n.name ? formatSavedDate(n.savedAt) : '', n.orderName ? 'From order ' + n.orderName : '', n.quality, n.method, n.length, n.weight].filter(Boolean).join(' · ');
        if (meta) { var mp = el('p', 'ccs__saved-meta'); mp.textContent = meta; info.appendChild(mp); }
        var sw = el('div', 'ccs__saved-swatches');
        sw.setAttribute('aria-hidden', 'true');
        n.sides.forEach(function (s, i) {
          if (i > 0) sw.appendChild(el('span', 'ccs__saved-sep', '/'));
          if (s.rootShade && s.rootLength && s.rootLength !== 'None') { var r = savedDot(s.rootShade, pool); r.classList.add('is-root'); sw.appendChild(r); }
          s.colours.forEach(function (l) { sw.appendChild(savedDot(l, pool)); });
        });
        if (sw.children.length) info.appendChild(sw);
        var shades = savedShadesText(n);
        if (shades) { var sp = el('p', 'ccs__saved-shades'); sp.textContent = shades; info.appendChild(sp); }
        if (n.colourCode) { var cc = el('code', 'ccs__saved-code'); cc.textContent = n.colourCode; info.appendChild(cc); }
        li.appendChild(info);
        var actions = el('div', 'ccs__saved-actions');
        var btn = el('button', 'button-secondary ccs__saved-load');
        btn.type = 'button';
        btn.textContent = 'Load';
        btn.setAttribute('aria-label', 'Load blend: ' + title);
        btn.addEventListener('click', function () { applySaved(n); });
        actions.appendChild(btn);
        if (SAVED_ID.test(n.id)) savedDeleteUi(n, title, actions, btn);
        li.appendChild(actions);
        saved.list.appendChild(li);
      });
      saved.list.hidden = !entries.length;
      if (saved.empty) saved.empty.hidden = !!entries.length;
      if (saved.count) saved.count.textContent = entries.length ? '(' + entries.length + ')' : '';
    }
    // Any accepted shape in, sorted list out. Used for the Liquid-rendered value
    // and for the `blends` list the backend returns after a save or delete.
    function showSaved(raw) {
      var entries = savedList(raw).map(normaliseSaved).filter(Boolean);
      // Newest first when the entries carry dates; otherwise keep the stored order.
      if (entries.every(function (n) { return savedTime(n) != null; })) entries.sort(function (a, b) { return savedTime(b) - savedTime(a); });
      renderSaved(entries);
    }

    /* ---- saved blends: save and delete ---- */
    // Writes go to the members backend through the app proxy (the creator
    // dashboard uses the same /apps/members base). It answers with the whole
    // updated list as `blends`, which is redrawn in place. Saves come from the
    // Save blend button and from every successful add to cart (autoSaveBlend).
    // The theme editor has no customer and must never write, so design mode
    // makes no requests.
    //   POST   /apps/members/saved-colours      { name?, variantId, properties }
    //   DELETE /apps/members/saved-colours/:id
    var SAVED_URL = '/apps/members/saved-colours';
    var SAVED_ID = /^[A-Za-z0-9_-]{1,80}$/; // ids the backend accepts for DELETE
    var EDITOR_MSG = 'Saved blends can\'t be changed in the theme editor.';
    var saveUi = null;
    function designMode() { return !!(window.Shopify && window.Shopify.designMode); }
    function setSavedMsg(t) { if (saved.msg) saved.msg.textContent = t; }
    // Status + parsed JSON body ({} when the body isn't JSON, e.g. a proxy error page).
    function savedResponse(r) {
      return r.json().catch(function () { return null; }).then(function (d) {
        return { status: r.status, ok: r.ok, data: (d && typeof d === 'object') ? d : {} };
      });
    }
    function readyToSave() { return isComplete(state) && !!resolveVariant(product, state) && !!buildColourCode(state); }
    // The one save request, shared by Save blend and add to cart. keepalive lets
    // the add-to-cart save finish while the page moves on to /cart.
    function postSaved(body, keepalive) {
      return fetch(SAVED_URL, { method: 'POST', keepalive: !!keepalive, headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(savedResponse);
    }
    function typedName() { return saveUi ? saveUi.name.value.trim().slice(0, 60) : ''; }
    function saveKey(code, variantId) { return code + '\u001f' + variantId; }
    var lastManualSave = ''; // saveKey of the last successful Save blend press
    function saveBlend() {
      if (!saveUi || saveUi.busy || !readyToSave()) return;
      if (designMode()) { dom.msg.textContent = EDITOR_MSG; return; }
      var code = buildColourCode(state);
      var variantId = String(resolveVariant(product, state).id);
      var body = { variantId: variantId, properties: cartProperties(code) };
      var name = typedName();
      if (name) body.name = name;
      saveUi.busy = true;
      saveUi.btn.disabled = true;
      dom.msg.textContent = 'Saving…';
      function done(m) {
        saveUi.busy = false;
        saveUi.btn.disabled = !readyToSave();
        dom.msg.textContent = m;
      }
      postSaved(body)
        .then(function (res) {
          if (res.ok && res.data.ok) {
            lastManualSave = saveKey(code, variantId);
            if (Array.isArray(res.data.blends)) showSaved(res.data.blends);
            saved.panel.open = true;
            saved.list.scrollTop = 0;
            saveUi.name.value = '';
            setSavedMsg('');
            done('Saved to your account.');
          } else if (res.status === 403) done('Log in to save blends.');
          else if (res.status === 400) done('Couldn\'t save this blend.');
          else done('Couldn\'t save just now. Please try again.');
        }, function () { done('Couldn\'t save just now. Please try again.'); });
    }
    // Called after a successful add to cart with the variant and properties that
    // went to /cart/add.js. Saves the same blend to the account, with the typed
    // name if there is one. saveUi only exists for a logged-in eligible customer
    // (or the editor, which never writes). Fire and forget: the cart add has
    // already succeeded, so this never blocks it and a failure is only logged.
    // Skipped when Save blend already saved this exact blend and no new name is
    // typed; the backend also dedupes identical blends.
    function autoSaveBlend(variantId, code, properties) {
      try {
        if (!saveUi || designMode()) return;
        var name = typedName();
        if (!name && saveKey(code, String(variantId)) === lastManualSave) return;
        var body = { variantId: String(variantId), properties: properties };
        if (name) body.name = name;
        postSaved(body, true).then(function (res) {
          if (res.ok && res.data.ok) { if (Array.isArray(res.data.blends)) showSaved(res.data.blends); }
          else console.warn('CCS: saving the blend after add to cart failed (' + res.status + ')', res.data.error || '');
        }, function (err) { console.warn('CCS: saving the blend after add to cart failed', err); });
      } catch (err) { console.warn('CCS: saving the blend after add to cart failed', err); }
    }
    // "Save blend" + optional name, next to Add to cart. Built here rather than in
    // Liquid so it only exists alongside the panel (logged-in eligible customer,
    // or the theme editor).
    function buildSaveUi() {
      var row = el('div', 'ccs__save-row');
      var input = document.createElement('input');
      input.type = 'text';
      input.className = 'ccs__save-name';
      input.maxLength = 60;
      input.autocomplete = 'off';
      input.placeholder = 'Name this blend (optional)';
      input.setAttribute('aria-label', 'Name this blend (optional)');
      var btn = el('button', 'button-secondary ccs__save');
      btn.type = 'button';
      btn.textContent = 'Save blend';
      btn.disabled = true;
      row.appendChild(input);
      row.appendChild(btn);
      dom.add.parentNode.insertBefore(row, dom.add.nextSibling);
      btn.addEventListener('click', saveBlend);
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); if (!btn.disabled) saveBlend(); } });
      return { row: row, name: input, btn: btn, busy: false };
    }
    // Delete with an inline confirm: Delete -> "Remove?" Yes / No. Focus goes to
    // No (the safe answer) and Escape backs out.
    function savedDeleteUi(n, title, actions, load) {
      var del = el('button', 'button-secondary ccs__saved-delete');
      del.type = 'button';
      del.textContent = 'Delete';
      del.setAttribute('aria-label', 'Delete blend: ' + title);
      var confirm = el('div', 'ccs__saved-confirm');
      confirm.setAttribute('role', 'group');
      confirm.setAttribute('aria-label', 'Remove ' + title + '?');
      confirm.hidden = true;
      var q = el('span', 'ccs__saved-confirm-q');
      q.textContent = 'Remove?';
      var yes = el('button', 'button-secondary ccs__saved-yes');
      yes.type = 'button';
      yes.textContent = 'Yes';
      yes.setAttribute('aria-label', 'Yes, remove ' + title);
      var no = el('button', 'button-secondary ccs__saved-no');
      no.type = 'button';
      no.textContent = 'No';
      no.setAttribute('aria-label', 'No, keep ' + title);
      confirm.appendChild(q);
      confirm.appendChild(yes);
      confirm.appendChild(no);
      function ask(on) { del.hidden = on; confirm.hidden = !on; (on ? no : del).focus(); }
      del.addEventListener('click', function () { ask(true); });
      no.addEventListener('click', function () { ask(false); });
      confirm.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !yes.disabled) { e.preventDefault(); e.stopPropagation(); ask(false); }
      });
      yes.addEventListener('click', function () { deleteSaved(n, [load, yes, no], function () { ask(false); }); });
      actions.appendChild(del);
      actions.appendChild(confirm);
    }
    function deleteSaved(n, controls, cancel) {
      if (designMode()) { cancel(); setSavedMsg(EDITOR_MSG); return; }
      function lock(on) { controls.forEach(function (b) { b.disabled = on; }); }
      lock(true);
      setSavedMsg('Removing…');
      fetch(SAVED_URL + '/' + encodeURIComponent(n.id), { method: 'DELETE', headers: { 'Accept': 'application/json' } })
        .then(savedResponse)
        .then(function (res) {
          // 404 = already gone (another tab, or a re-saved list); both carry the list.
          if ((res.status === 200 || res.status === 404) && Array.isArray(res.data.blends)) {
            showSaved(res.data.blends);
            setSavedMsg(res.status === 200 ? 'Blend removed.' : 'That blend had already been removed.');
            var sum = saved.panel.querySelector('summary');
            if (sum) sum.focus();
            return;
          }
          throw res;
        })
        .catch(function (res) {
          lock(false);
          cancel();
          setSavedMsg(res && res.status === 403 ? 'Log in to delete saved blends.' : 'Couldn\'t delete just now. Please try again.');
        });
    }

    if (saved.panel && saved.list) {
      var rawSaved = null;
      try { rawSaved = saved.data ? JSON.parse(saved.data.textContent) : null; } catch (e) { rawSaved = null; }
      showSaved(rawSaved);
      if (dom.add && dom.add.parentNode) saveUi = buildSaveUi();
    }

    render();
  }

  /* ===================== modal (block trigger) ===================== */
  var modalsBound = false;
  function bindModals() {
    if (modalsBound) return; modalsBound = true;
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-ccs-open]');
      if (opener) { var id = opener.getAttribute('data-ccs-open'); var dlg = id ? document.getElementById(id) : document.querySelector('dialog[data-ccs-modal]'); if (dlg) { dlg.showModal ? dlg.showModal() : dlg.setAttribute('open', ''); } return; }
      var closer = e.target.closest('[data-ccs-close]');
      if (closer) { var d = closer.closest('dialog'); if (d) { d.close ? d.close() : d.removeAttribute('open'); } return; }
      if (e.target.matches && e.target.matches('dialog[data-ccs-modal]')) e.target.close && e.target.close();
    });
  }

  function boot() { bindModals(); document.querySelectorAll('[data-ccs]').forEach(initBuilder); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
